/*

Lalitha 10/27/2022 3225736869 night jobs UX changes
Ashraf 12/16/2022 3225736869 fixed role based access

*/
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AddJob from './AddJob';
import SearchNightJob from './SearchNightJob';
import JobDetails from './JobDetails';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function NightJobTabs({groupId, setTabValue, roleDataNJobs, setSelected, selected}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [jobCode, setJobCode] = useState('');
  const [isCopyRowData, setIsCopyRowData] = useState(false);
  const [nightJobCode, setNightJobCode] = useState('');
  useEffect(() => {
    if (groupId !== '') {
      setValue(1);
    }
  }, [groupId]);
  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? <SearchNightJob setSelected={setSelected} setTabValue={setTabValue} 
          setValue={setValue} setJobCode={setJobCode} setNightJobCode={setNightJobCode} setIsCopyRowData={setIsCopyRowData}/> :
          value === 1 ? (
            <AddJob
              setValue={setValue}
              setTabValue={setTabValue}
              nightJobCode={nightJobCode}
              setNightJobCode={setNightJobCode}
              isCopyRowData={isCopyRowData}
              roleDataNJobs={roleDataNJobs}
              selected={selected}
            />
          ) :
            value === 2 && (
              <JobDetails
                setValue={setValue}
                setTabValue={setTabValue}
                jobCode={jobCode}
              />
            )}
      </div>
    </div>
  );
}
